<template>
  <div class="more-details">
    <Heading
      font-size="48px"
      line-height="72px"
      letter-spacing="-0.015em"
      font-color="#000000"
      class="more-details__title"
    >
      Mais detalhes e acabamentos
    </Heading>
    <section class="more-details-content">
      <div
        v-for="({ title, paragraph }, i) in details"
        :key="i"
        class="more-details-content__item"
      >
        <Heading
          font-weight="bold"
          font-size="24px"
          line-height="36px"
          letter-spacing="-0.015em"
          font-color="#000000;"
          level="2"
        >
          {{ title }}
        </Heading>
        <p class="more-details-content__paragraph">
          {{ paragraph }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'MoreDetails',
  components: { Heading },
  data() {
    return {
      details: [
        {
          title: 'Sed ut perspiciatis',
          paragraph:
            'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est.',
        },
        {
          title: 'Lorem ipsum dolor',
          paragraph:
            'Amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.',
        },
        {
          title: 'Nemo enim ipsam',
          paragraph:
            'Consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam.',
        },
        {
          title: 'Tempor incididunt',
          paragraph:
            'Eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora.',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import '@/static/css/Variables.scss';
.more-details {
  padding: 120px 80px;
  @media (max-width: $md) {
    padding: 0 20px;
    margin-top: 30px;
  }
  &__title {
    width: 30%;
    @media (max-width: $lg) {
      width: 100%;
      font-size: 24px !important;
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (max-width: $sm) {
      flex-direction: column;
    }
    &__item {
      width: 45%;
      margin-top: 60px;
      @media (max-width: $md) {
        width: 100%;
        margin-top: 10px;
      }
    }
    &__paragraph {
      font-size: 18px;
      line-height: 22px;
      letter-spacing: -0.015em;
      color: rgba(0, 0, 0, 0.8);
      margin-top: 25px;

      @media (max-width: $lg) {
        font-size: 14px !important;
      }
    }
  }
}
</style>
